import * as mayachain from '../../parser/mayachain';
const opReturnRegex = /OP_RETURN \((?<memo>[^)]+)\)/;
export class Parser {
    parser;
    constructor(args) {
        this.parser = new mayachain.Parser({ midgardUrl: args.midgardUrl });
    }
    async parse(tx) {
        const opReturn = tx.vout.find(vout => vout.opReturn)?.opReturn;
        if (!opReturn)
            return;
        const memo = opReturn.match(opReturnRegex)?.groups?.memo;
        if (!memo)
            return;
        return await this.parser.parse(memo, tx.txid);
    }
}
